module.exports = __webpack_public_path__ + "img/swatchbook.df433f4d.svg";